import { Component, Input, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LoadingSpinnerComponent {
  @Input() isLoading: boolean
  @Input() label: string
  @Input() classesString: string
  @Input() spinnerOverlayAddedClass: string
}
